import { Resources } from "@tsTypes/subject-schema";
import {
  buildFullPath,
  buildSubjectSlug,
  getBannerLinksForContext,
  getResourceDisplayName,
  isResourceAllowedForSubject,
} from "@utils/routing";
import ResourceBanner from "./ResourceBanner";

export default function LinkedUsefulResourceBanner({
  subject,
  currentResource,
  linkedResource,
}: {
  subject: string;
  currentResource: Resources;
  linkedResource?: Resources | "all" | null;
}) {
  const bestNextLink =
    linkedResource && linkedResource !== "all"
      ? isResourceAllowedForSubject(subject, linkedResource)
        ? {
            label: getResourceDisplayName(linkedResource),
            href: buildFullPath({
              subject: subject,
              resource: linkedResource,
            }),
            resource: linkedResource,
          }
        : null
      : linkedResource === "all"
      ? {
          label: "Subject overview",
          href: buildSubjectSlug(subject),
          resource: "all" as const,
        }
      : null;

  return (
    <ResourceBanner
      subject={subject}
      currentResourceMessage={getResourceMessage(currentResource)}
      suggestedLink={bestNextLink}
      linksHeading={"Other useful resources"}
      links={getBannerLinksForContext({
        context: "useful",
        subjectNameLower: subject,
        currentResource,
      })}
    />
  );
}

function getResourceMessage(resource: Resources) {
  switch (resource) {
    case "syllabus":
      return `syllabus points`;
    case "exam breakdown":
      return `exam breakdowns`;
    case "ia examples":
      return `IA examples`;
    case "ia criteria":
      return `IA marking criteria`;
    case "command terms":
      return `IB command terms`;
  }
  return resource;
}
